import React from 'react';
import { Container } from 'reactstrap';

const BlankContainer = () => {
  return (
    <Container fluid className='flex-fill bg-grayBg'/>
  );
};

export default BlankContainer;